// Components==============
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext } from 'react';
import { ExpandedMenuTypes, loginContext, Options } from '../Login';
import './Dropdown.module.scss';
// =========================

type Props = {
    options: Options;
    type: ExpandedMenuTypes;
    setState: any;
};

export default function Dropdown({ options, type, setState }: Props) {
    const {
        expandedMenu,
        setExpandedMenu,
        buildingType,
        groundPlane,
        selectedColor,
        setLoginFailed,
    } = useContext(loginContext);

    function selectClick(clickedSelect: ExpandedMenuTypes) {
        if (clickedSelect === expandedMenu) {
            setExpandedMenu('none');
        } else {
            setExpandedMenu(clickedSelect);
        }
    }
    // console.log(options);
    return (
        <div
            onClick={() => {
                selectClick(type);
            }}
            styleName={` dropdown  ${type || ''} ${
                type === 'colors' ? selectedColor : ''
            } ${type === 'groundplane' ? groundPlane : ''} `}
        >
            {type === 'buildings' && <p>{buildingType}</p>}
            {type === 'groundplane' && (
                <p>
                    <FontAwesomeIcon
                        styleName="ground-plane-icon"
                        icon={
                            options.find(
                                (option) => option.option === groundPlane
                            )?.icon
                        }
                    />
                    {groundPlane}
                </p>
            )}
            <FontAwesomeIcon styleName="chevron" icon={faChevronDown} />
            <AnimatePresence>
                {expandedMenu === type && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        styleName="options"
                    >
                        {options.map(function (item, i) {
                            if (type === 'colors') {
                                return (
                                    <div
                                        styleName="wrapper "
                                        key={i}
                                        onClick={() => {
                                            setLoginFailed(false);
                                            setState(item.option);
                                        }}
                                    >
                                        <div
                                            styleName={`circle ${
                                                item && item.option
                                                    ? item.option
                                                    : ''
                                            } `}
                                        />
                                        <p>{item.name}</p>
                                    </div>
                                );
                            }
                            return (
                                <div
                                    key={i}
                                    onClick={() => {
                                        setLoginFailed(false);
                                        setState(item.option);
                                    }}
                                    styleName={`circle ${
                                        item && item.option ? item.option : ''
                                    } ${
                                        buildingType === item.option
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    <FontAwesomeIcon icon={item.icon} />
                                </div>
                            );
                        })}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
